export default class ScrollDetect {
  constructor() {
    this.scrollIcon = null;
    this.contactBtn = null;
  }

  init() {
    this.scrollIcon = document.querySelector('.banner__scroll');
    this.contactBtn = document.querySelector('.header__contact-btn');

    //set init pos
    this.setScrollIcon();
    this.setContactBtn();

    window.addEventListener('scroll', (e) => this.handleScroll(e));
  }

  handleScroll(e) {
    this.setScrollIcon();
    this.setContactBtn();
  }

  setScrollIcon() {
    if (this.scrollIcon) {
      if (window.scrollY > 0) {
        //has started scrolling
        //so remove
        this.scrollIcon.classList.remove('show');
      } else {
        //not started so show it
        this.scrollIcon.classList.add('show');
      }
    }
  }

  setContactBtn() {
    if (this.contactBtn) {
      if (window.scrollY > 0) {
        //has started scrolling
        //so remove
        this.contactBtn.classList.add('show');
      } else {
        //not started so show it
        this.contactBtn.classList.remove('show');
      }
    }
  }
}
